/*
  Shop by sport tabs.

  All sports' panels are rendered server-side; this only swaps which one is
  visible. Follows the ARIA tabs pattern: one tab in the tab order at a time,
  arrow keys move between them.
*/
(function () {
  'use strict';

  function tabsIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.sport-tabs__tab'));
  }

  function select(root, tab, focusTab) {
    var tabs = tabsIn(root);
    var index = tabs.indexOf(tab);
    if (index === -1) return;

    tabs.forEach(function (t) {
      var active = t === tab;
      var panel = document.getElementById(t.getAttribute('aria-controls'));

      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      // Only the active tab stays tabbable, so Tab leaves the tablist rather
      // than walking through all six.
      t.setAttribute('tabindex', active ? '0' : '-1');

      if (panel) panel.hidden = !active;
    });

    if (focusTab) tab.focus();

    // Keep the newly selected tab visible when the row is scrolled sideways.
    // The row is scrolled directly rather than via scrollIntoView, which also
    // scrolls the page vertically when the tab row is out of view.
    var row = tab.parentElement;
    if (row && row.scrollWidth > row.clientWidth) {
      var left = tab.offsetLeft - row.offsetLeft;
      var right = left + tab.offsetWidth;
      if (left < row.scrollLeft) row.scrollLeft = Math.max(0, left - 8);
      else if (right > row.scrollLeft + row.clientWidth) row.scrollLeft = right - row.clientWidth + 8;
    }
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.sport-tabs__tab');
    if (!tab) return;

    var root = tab.closest('.sport-tabs');
    if (!root) return;

    event.preventDefault();
    select(root, tab, false);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('.sport-tabs__tab');
    if (!tab) return;

    var root = tab.closest('.sport-tabs');
    if (!root) return;

    var tabs = tabsIn(root);
    var i = tabs.indexOf(tab);
    var next = null;

    switch (event.key) {
      case 'ArrowRight':
        next = tabs[(i + 1) % tabs.length];
        break;
      case 'ArrowLeft':
        next = tabs[(i - 1 + tabs.length) % tabs.length];
        break;
      case 'Home':
        next = tabs[0];
        break;
      case 'End':
        next = tabs[tabs.length - 1];
        break;
      default:
        return;
    }

    event.preventDefault();
    select(root, next, true);
  });
})();

/*
  Per-sport product carousel — endless loop.

  Any sport with at least `data-loop-min` products (4 by default) gets an
  arrow-driven carousel that never reaches an end: the product set is cloned
  until the track is comfortably wider than the viewport, and once the scroll
  passes one full set it is silently rewound by exactly that distance. Because
  the content at both positions is identical, the rewind is invisible.

  Sports below the threshold keep a plain row with no arrows, rather than being
  padded out with empty slots.
*/
(function () {
  'use strict';

  function parts(root) {
    return {
      track: root.querySelector('[data-sport-track]'),
      prev: root.querySelector('[data-sport-prev]'),
      next: root.querySelector('[data-sport-next]')
    };
  }

  function originalsOf(track) {
    return Array.prototype.filter.call(track.children, function (el) {
      return el.dataset.sportClone !== '1';
    });
  }

  function build(root) {
    var p = parts(root);
    if (!p.track) return;

    // Drop previous clones before measuring, or a rebuild would treat them as
    // originals and multiply the track on every resize.
    Array.prototype.slice.call(p.track.children).forEach(function (el) {
      if (el.dataset.sportClone === '1') p.track.removeChild(el);
    });

    var originals = originalsOf(p.track);
    var min = parseInt(root.getAttribute('data-loop-min'), 10);
    if (!min || isNaN(min)) min = 4;

    var loop = originals.length >= min && originals.length > 0;
    root.classList.toggle('is-loop', loop);
    if (p.prev) p.prev.hidden = !loop;
    if (p.next) p.next.hidden = !loop;
    root._setW = 0;

    if (!loop) return;

    // A hidden panel measures zero; leave it for the re-sync on tab change.
    var view = p.track.clientWidth;
    if (!view) return;

    var oneSet = p.track.scrollWidth;
    // Enough copies that the scroll can always travel a full set past the
    // start without running out of track.
    var copies = Math.max(3, Math.ceil((view * 2) / Math.max(oneSet, 1)) + 2);

    for (var c = 1; c < copies; c++) {
      originals.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.dataset.sportClone = '1';
        clone.setAttribute('aria-hidden', 'true');
        // Cloned cards must not be reachable by keyboard or screen readers.
        Array.prototype.forEach.call(clone.querySelectorAll('a, button, input'), function (el) {
          el.setAttribute('tabindex', '-1');
        });
        p.track.appendChild(clone);
      });
    }

    // Exact distance of one set, measured from the DOM rather than assumed.
    var firstClone = p.track.querySelector('[data-sport-clone="1"]');
    root._setW = firstClone ? firstClone.offsetLeft - originals[0].offsetLeft : 0;

    // Advance one card per click rather than a whole row. With a set that is
    // exactly as wide as the viewport (a sport with precisely four products),
    // a full-row step would move by exactly one set and the rewind would undo
    // it, leaving the carousel looking frozen.
    root._stepW = originals.length > 1
      ? originals[1].offsetLeft - originals[0].offsetLeft
      : originals[0].offsetWidth;

    p.track.scrollLeft = 0;
  }

  // Keep the scroll position inside the first set, so there is always a full
  // set of content on either side to scroll into.
  function rewind(root) {
    var p = parts(root);
    var w = root._setW;
    if (!w || !p.track) return;

    var prevBehavior = p.track.style.scrollBehavior;
    p.track.style.scrollBehavior = 'auto';
    while (p.track.scrollLeft >= w) p.track.scrollLeft -= w;
    while (p.track.scrollLeft < 0) p.track.scrollLeft += w;
    p.track.style.scrollBehavior = prevBehavior;
  }

  // The instant jump used when paging backwards also fires `scrollend`, which
  // would run the rewind before the smooth scroll had finished and cancel it.
  // Waiting for the position to actually stop changing avoids that race.
  function whenSettled(track, fn) {
    var done = false;
    var last = -1;
    var stable = 0;

    function finish() {
      if (done) return;
      done = true;
      clearInterval(poll);
      fn();
    }

    var poll = setInterval(function () {
      var now = Math.round(track.scrollLeft);
      if (now === last) stable++;
      else { stable = 0; last = now; }
      if (stable >= 3) finish();
    }, 60);

    // Never poll indefinitely.
    setTimeout(finish, 2000);
  }

  function page(root, dir) {
    var p = parts(root);
    var w = root._setW;
    if (!p.track || !w) return;

    var step = root._stepW || p.track.clientWidth;

    // The scroll listener below also rewinds, for swipes. Without this flag it
    // fires during the jump-forward step and cancels the move.
    root._paging = true;

    if (dir < 0 && p.track.scrollLeft - step < 0) {
      // Jump a set forward first so there is room to scroll backwards into.
      var prevBehavior = p.track.style.scrollBehavior;
      p.track.style.scrollBehavior = 'auto';
      p.track.scrollLeft += w;
      p.track.style.scrollBehavior = prevBehavior;
    }

    var target = p.track.scrollLeft + dir * step;
    p.track.scrollTo({ left: target, behavior: 'smooth' });

    whenSettled(p.track, function () {
      rewind(root);
      root._paging = false;
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-sport-prev], [data-sport-next]');
    if (!btn) return;
    var root = btn.closest('[data-sport-carousel]');
    if (!root) return;
    event.preventDefault();
    page(root, btn.hasAttribute('data-sport-next') ? 1 : -1);
  });

  // Swiping on a phone should loop too, not just the arrows.
  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track || !track.hasAttribute || !track.hasAttribute('data-sport-track')) return;
      var root = track.closest('[data-sport-carousel]');
      if (!root || !root._setW || root._paging) return;
      clearTimeout(track._sportTimer);
      track._sportTimer = setTimeout(function () {
        rewind(root);
      }, 140);
    },
    true
  );

  function buildAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sport-carousel]'), build);
  }

  // Panels are hidden until their tab is chosen, and hidden elements measure
  // zero, so rebuild once a panel becomes visible.
  document.addEventListener('click', function (event) {
    if (event.target.closest('.sport-tabs__tab')) setTimeout(buildAll, 40);
  });

  var t = null;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(buildAll, 220);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildAll);
  } else {
    buildAll();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(buildAll).catch(function () {});
  }
})();
